import { useEffect, useState} from 'react';
import axios from '../../axios.js';
import CircularProgress  from '@mui/material/CircularProgress';
import { useLocation, useNavigate } from "react-router-dom";

import Results from '../../components/Results/Results';
import Pager from '../../components/Pager/Pager';
import Facets from '../../components/Facets/Facets';
import SearchBar from '../../components/SearchBar/SearchBar';
import "./Search.css";


export default function Search_Fr() {
  
  let location = useLocation();
  const navigate = useNavigate();
  
  const [ results, setResults ] = useState([]);
  const [ resultCount, setResultCount ] = useState(0);
  const [ currentPage, setCurrentPage ] = useState(1);
  const [ q, setQ ] = useState(new URLSearchParams(location.search).get('q') ?? "*");
  const [ top ] = useState(new URLSearchParams(location.search).get('top') ?? 10);
 // const [ skip, setSkip ] = useState(new URLSearchParams(location.search).get('skip') ?? 0);
 let skip = (currentPage - 1) * top;
  const [ filters, setFilters ] = useState([]);
  const [ facets, setFacets ] = useState({});
  const [ isLoading, setIsLoading ] = useState(true);
  const [sortDate, setSortDate] = useState(false);

  let resultsPerPage = top;
  
  useEffect(() => {
    setIsLoading(true);

    //setSkip((currentPage-1) * top);
    const body = {
      q: q,
      top: top,
      skip: skip,
      filters: filters,
      sortDate: sortDate,
      isFrench: true,
    };

    axios.post( '/api/search', body)
      .then(response => {
            setResults(response.data.result.results);
            setFacets(response.data.result.facets);
            setResultCount(response.data.result.count);
            setIsLoading(false);
        } )
        .catch(error => {
            console.log(error);
            setIsLoading(false);
        });
    
  }, [q, top, filters,skip, currentPage, sortDate]);

  // pushing the new search term to history when q is updated
  // allows the back button to work as expected when coming back from the details page
useEffect(() => {
  navigate('/search-fr?q=' + q);
  setCurrentPage(1);
  setFilters([]);
}, [q, navigate, setCurrentPage, setFilters]);


  const postSearchHandler = async (searchTerm) => {
    //const word = await checkSpelling(searchTerm);
    setQ(searchTerm);
  };

  var body;
  if (isLoading) {
    body = (
  <div
    style={{
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: '5%',
  }}
>
  <CircularProgress style={{ color: '#14143c' }} />
</div>);
  } else {
    body = (
      <div className="col-md-12">
        <Results documents={results} top={top} skip={skip} count={resultCount} query={q} sortDate={sortDate} setSortDate={setSortDate} color={'#14143C'} ></Results>
        <Pager className="pager-style" currentPage={currentPage} resultCount={resultCount} resultsPerPage={resultsPerPage} setCurrentPage={setCurrentPage} color={'#14143C'} ></Pager>
      </div>
    )
  }

  // filters should be applied across entire result set, 
  // not just within the current page
  const updateFilterHandler = (newFilters) => {

    // Reset paging
    //setSkip(0); 
    setCurrentPage(1);

    // Set filters
    setFilters(newFilters);
  };

  return (
 <main className="container-fluid px-4 py-3">
    {/* Top Search Bar */}
    <div className="row mb-4">
      <div className="col-12">
        <div className="d-flex">
          <SearchBar postSearchHandler={postSearchHandler} query={q} color={'#14143C'} source={'cim-eng'} isFrench={true}/>
          {/* Optional search button if SearchBar doesn’t include it */}
          {/* <button className="btn btn-primary ms-2">Search</button> */}
        </div>
      </div>
    </div>
  
    {/* Main content area: 70% body, 30% facets */}
    <div className="row">
      {/* Left: Body content (70%) */}
      <div className="col-md-8">
        {body}
      </div>
  
      {/* Right: Facets (30%) */}
      <div className="col-md-4">
        <Facets 
          facets={facets} 
          filters={filters} 
          setFilters={updateFilterHandler} 
        />
      </div>
    </div>
  </main>
  
  );
}
